// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border-right[data-v-64f96bc2]{border-color:#d8d8d8}[data-v-64f96bc2] .v-data-table>.v-data-table__wrapper>table>tbody>tr>td:first-child{font-size:16px}[data-v-64f96bc2] td:last-child{background-color:#fffce3}[data-v-64f96bc2] .v-input--switch .v-label{font-size:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
